module.exports = __webpack_public_path__ + "img/5.392b5bca.jpg";